import Link from 'next/link'
import styled, { useTheme } from 'styled-components'
import FlatIcon from '@/components/common/icons/FlatIcon'
import { Typo, TypoVariant } from '@/components/common/typography'
import { IconNameEnum } from '@/constants/icon-name.enum'
import { encodeId } from '@/utils/utilApi'

interface ProductDetailExchangeRefundGuideProps {
  productId: number
}
// TODO: link url products-new -> products로 수정
export const ProductDetailExchangeRefundGuide = ({ productId }: ProductDetailExchangeRefundGuideProps) => {
  const { color } = useTheme()
  const encodedProductId = encodeId('ProductType', productId)
  return (
    <ProductDetailExchangeRefundGuideWrapper className="product-detail-exchange-refund-guide">
      {/* <Link href={`/products-new/${encodedProductId}/exchange-refund-guide`}> */}
      <Link href={`/products/${encodedProductId}/exchange-refund-guide`}>
        <div className="product-detail-exchange-refund-guide__link-button">
          <Typo as="h2" variant={TypoVariant.Heading6Bold} color={color.gray900}>
            교환/환불/품절 안내
          </Typo>
          <FlatIcon type={IconNameEnum.IcChevronRight} color={color.gray400} />
        </div>
      </Link>
    </ProductDetailExchangeRefundGuideWrapper>
  )
}

const ProductDetailExchangeRefundGuideWrapper = styled.div`
  .product-detail-exchange-refund-guide {
    &__link-button {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
`
